

import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { IArrowDrawable } from "../../../../../domain/document/items";
import { Point, Size, LineStyle, ArrowKinds } from "../../../../../domain/drawing";
import { SvgPathFactory } from "../../../../drawing/utilities";

@Component({
})
export default class ArrowDrawableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: IArrowDrawable) => T, defaultValue: T) => T;
  privateId: number;
  lineStyle: LineStyle;
  draggableStrokeWidth: number;

  get arrowKind(): ArrowKinds {
    return this.readPropertyOrDefault(s => s.arrowKind, undefined);
  }

  get arrowSize(): Size {
    return new Size(16, 16);
  }

  get arrowDrawerOffset(): Point {
    return new Point(
      Math.ceil((this.draggableStrokeWidth + this.arrowSize.width) / 2),
      Math.ceil((this.draggableStrokeWidth + this.arrowSize.height) / 2));
  }

  get arrowDrawerSize(): Size {
    return Size.from(this.arrowDrawerOffset.multiply(2));
  }

  get arrowStyleProperties() {
    return {
      fill: "none",
      stroke: this.lineStyle.color.value,
      strokeWidth: this.lineStyle.width,
    };
  }

  get arrowDrawOffset(): Point {
    return new Point(this.lineStyle.width / 2, this.lineStyle.width / 2);
  }

  get arrowFrom(): { offset: Point, path: string, id: string, url: string } {
    return this.createArrowAttributes(
      ArrowKinds.ArrowFrom,
      new Point(0, this.arrowSize.height / 2),
      [
        new Point(this.arrowSize.width, 0),
        new Point(0, this.arrowSize.height / 2),
        new Point(this.arrowSize.width, this.arrowSize.height)
      ],
      "back"
    );
  }

  get arrowTo(): { offset: Point, path: string, id: string, url: string } {
    return this.createArrowAttributes(
      ArrowKinds.ArrowTo,
      new Point(this.arrowSize.width, this.arrowSize.height / 2),
      [
        new Point(0, 0),
        new Point(this.arrowSize.width, this.arrowSize.height / 2),
        new Point(0, this.arrowSize.height)
      ],
      "head"
    );
  }

  private createArrowAttributes(kind: ArrowKinds, offset: Point, points: Point[], key: string): { offset: Point, path: string, id: string, url: string } {
    const id = this.formatArrowId(key);
    return {
      offset: offset.add(this.arrowDrawOffset),
      path: this.formatArrowPath(points),
      id,
      url: this.isArrowVisible(kind) ? this.formatArrowUrl(id) : null,
    };
  }

  private formatArrowId(key: string): string {
    return "arrow-" + key + "-" + this.privateId;
  }

  private formatArrowPath(points: Point[]): string {
    const offsetPoints = Enumerable.from(points)
      .select(p => p.add(this.arrowDrawOffset))
      .toArray();
    return SvgPathFactory.createPolyline(...offsetPoints);
  }

  private isArrowVisible(kind: ArrowKinds): boolean {
    return  (this.arrowKind === kind)
      || (this.arrowKind === ArrowKinds.ArrowBoth);
  }

  private formatArrowUrl(id: string): string {
    return "url(#" + id + ")";
  }
}
